function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { TabBars } from './TabBars';
export function TabsImpl(props) {
  var className = props.className,
      onEdit = props.onEdit,
      _props$hideAdd = props.hideAdd,
      hideAdd = _props$hideAdd === void 0 ? false : _props$hideAdd,
      _props$type = props.type,
      type = _props$type === void 0 ? 'basic' : _props$type,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$tabPosition = props.tabPosition,
      tabPosition = _props$tabPosition === void 0 ? 'top' : _props$tabPosition,
      extraTabBar = props.extraTabBar,
      renderTabBar = props.renderTabBar,
      children = props.children,
      barClassName = props.barClassName,
      beforeActiveChange = props.beforeActiveChange,
      onTabClick = props.onTabClick,
      extra = _objectWithoutProperties(props, ["className", "onEdit", "hideAdd", "type", "size", "tabPosition", "extraTabBar", "renderTabBar", "children", "barClassName", "beforeActiveChange", "onTabClick"]);

  var renderBar = function renderBar() {
    return React.createElement(TabBars, {
      hideAdd: hideAdd,
      type: type,
      onTabClick: onTabClick,
      extraTabBar: extraTabBar,
      renderTabBar: renderTabBar,
      tabPosition: tabPosition,
      onEdit: onEdit,
      className: barClassName,
      beforeActiveChange: beforeActiveChange,
      size: size
    }, children);
  };

  var render = function render() {
    switch (tabPosition) {
      case 'top':
      case 'left':
        return React.createElement(React.Fragment, null, renderBar(), children);

      case 'bottom':
      case 'right':
        return React.createElement(React.Fragment, null, children, renderBar());
    }
  };

  var cls = classnames(usePrefixCls('tab', {
    type: type,
    size: size,
    tabPosition: tabPosition
  }), className);
  return React.createElement("div", Object.assign({
    className: cls
  }, extra), render());
}